import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useDocumentTitle } from "./hooks/useDocumentTitle";
import DangNhapPage from "./pages/DangNhapPage";
import DashboardPage from "./pages/DashboardPage";
import RolePage from "./pages/RolePage";
import UserPage from "./pages/UserPage";
import AuthorPage from "./pages/AuthorPage";
import ImagePage from "./pages/ImagePage";
import NotFoundPage from "./pages/NotFoundPage";
import CategoryPage from "./pages/CategoryPage";
import RobotTxtPage from "./pages/RobotTxtPage";
import ArticlePage from "./pages/ArticlePage";

import EditArticlePage from "./pages/EditArticlePage.tsx";
import InformationManagementPage from "./pages/InformationManagementPage";
import { Toaster } from "@/components/ui/sonner";
import { ROUTES } from "@/constants/routes";
import CreatePagePage from "./pages/CreatePagePage.tsx";
import EditPagePage from "./pages/EditPagePage.tsx";
import PagePage from "./pages/PagePage.tsx";
import BlogPostPage from "./pages/BlogPostPage";
import CreateBlogPostPage from "./pages/CreateBlogPostPage";
import EditBlogPostPage from "./pages/EditBlogPostPage";
import MenuPage from "./pages/MenuPage";
import SidebarPage from "./pages/SidebarPage";
import TrendingMoviesPage from "./pages/TrendingMoviesPage";
import CommentPage from "./pages/CommentPage";
import SettingsPage from "./pages/SettingsPage";
import FilmListPage from "./pages/FilmListPage";
import ProfilePage from "./pages/ProfilePage";
import RedirectionPage from "./pages/RedirectionPage";
import AdSlotPage from "@/pages/AdSlotPage";
import ActorPage from "./pages/ActorPage";
import CreateActorPage from "./pages/CreateActorPage";
import EditActorPage from "./pages/EditActorPage";
import DirectorPage from "./pages/DirectorPage";
import CreateDirectorPage from "./pages/CreateDirectorPage";
import EditDirectorPage from "./pages/EditDirectorPage";
import CacheManagementPage from "./pages/CacheManagementPage";
import KKMoviePage from "./pages/KKMoviePage";
import KKMovieEpisodesPage from "./pages/KKMovieEpisodesPage";
import KKPhimSyncPage from "./pages/KKPhimSyncPage";
import OPhimSyncPage from "./pages/OPhimSyncPage";
import MovieImportPage from "./pages/MovieImportPage";

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  useDocumentTitle();

  return (
    <>
      <Routes>
        <Route path={ROUTES.LOGIN} element={<DangNhapPage />} />
        <Route
          path={ROUTES.DASHBOARD}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ROLES}
          element={
            <ProtectedRoute>
              <RolePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.USERS}
          element={
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CATEGORIES}
          element={
            <ProtectedRoute>
              <CategoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ARTICLES}
          element={
            <ProtectedRoute>
              <ArticlePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EDIT_ARTICLE}
          element={
            <ProtectedRoute>
              <EditArticlePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PAGES}
          element={
            <ProtectedRoute>
              <PagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CREATE_PAGE}
          element={
            <ProtectedRoute>
              <CreatePagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EDIT_PAGE}
          element={
            <ProtectedRoute>
              <EditPagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.BLOG_POSTS}
          element={
            <ProtectedRoute>
              <BlogPostPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CREATE_BLOG_POST}
          element={
            <ProtectedRoute>
              <CreateBlogPostPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EDIT_BLOG_POST}
          element={
            <ProtectedRoute>
              <EditBlogPostPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.MENUS}
          element={
            <ProtectedRoute>
              <MenuPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SIDEBAR}
          element={
            <ProtectedRoute>
              <SidebarPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TRENDING_MOVIES}
          element={
            <ProtectedRoute>
              <TrendingMoviesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PROFILE}
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.REDIRECTIONS}
          element={
            <ProtectedRoute>
              <RedirectionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.AD_SLOTS}
          element={
            <ProtectedRoute>
              <AdSlotPage />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={ROUTES.SERIES}
          element={
            <ProtectedRoute>
              <SeriesPage />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path={ROUTES.COMMENTS}
          element={
            <ProtectedRoute>
              <CommentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.AUTHORS}
          element={
            <ProtectedRoute>
              <AuthorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.IMAGES}
          element={
            <ProtectedRoute>
              <ImagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ROBOT_TXT}
          element={
            <ProtectedRoute>
              <RobotTxtPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.INFORMATION}
          element={
            <ProtectedRoute>
              <InformationManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.FILM_LIST}
          element={
            <ProtectedRoute>
              <FilmListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.HOME}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SETTINGS}
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ACTORS}
          element={
            <ProtectedRoute>
              <ActorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CREATE_ACTOR}
          element={
            <ProtectedRoute>
              <CreateActorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EDIT_ACTOR}
          element={
            <ProtectedRoute>
              <EditActorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.DIRECTORS}
          element={
            <ProtectedRoute>
              <DirectorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CREATE_DIRECTOR}
          element={
            <ProtectedRoute>
              <CreateDirectorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EDIT_DIRECTOR}
          element={
            <ProtectedRoute>
              <EditDirectorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.KKMOVIES}
          element={
            <ProtectedRoute>
              <KKMoviePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.KKMOVIE_EPISODES}
          element={
            <ProtectedRoute>
              <KKMovieEpisodesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.KKPHIM_SYNC}
          element={
            <ProtectedRoute>
              <KKPhimSyncPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.OPHIM_SYNC}
          element={
            <ProtectedRoute>
              <OPhimSyncPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.MOVIE_IMPORT}
          element={
            <ProtectedRoute>
              <MovieImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CACHE}
          element={
            <ProtectedRoute>
              <CacheManagementPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
